import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import { MatDatepicker } from "@angular/material/datepicker";
import {
  statusPaymentMap,
  statusPaymentColorMap,
} from "../../shared/constants";

@Component({
  selector: "app-voucher-manager",
  templateUrl: "./voucher-manager.component.html",
  styleUrls: ["./voucher-manager.component.scss"],
})
export class VoucherManagerComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router
  ) {}

  statusPaymentMap = statusPaymentMap;
  statusPaymentColorMap = statusPaymentColorMap;
  listData = [];
  pageSize = 10;
  pageIndex = 1;
  params = "";
  searching;
  totalCount = 0;
  tableName = "admin/customer-orders";
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  full_name = JSON.parse(localStorage.getItem("currentUser")).full_name;
  submitted: boolean;
  formData: FormGroup;
  listModel = ["MD712", "MD716", "MD760", "Y50", "Y56", "F91"];
  listVersion = ["Paybox", "Soundbox"];
  listStatus = [
    { value: "cancel", label: "Huỷ" },
    { value: "pending_payment", label: "Chờ thanh toán" },
    { value: "processing", label: "Đang đợi xử lý" },
    { value: "complete", label: "Đã liên kết loa" },
    { value: "ready_to_pick", label: "Sẵn sàng để lấy hàng" },
    { value: "picking", label: "Đang lấy hàng" },
    { value: "delivering", label: "Đang giao hàng" },
    { value: "transporting", label: "Đang vận chuyển" },
    { value: "money_collect_picking", label: "Thu tiền khi lấy hàng" },
    { value: "picked", label: "Đã lấy hàng" },
    { value: "storing", label: "Đang phân loại" },
    { value: "money_collect_delivering", label: "Thu tiền khi giao hàng" },
    { value: "delivered", label: "Đã giao hàng" },
    { value: "delivery_fail", label: "Giao hàng thất bại" },
    { value: "return_fail", label: "Trả hàng thất bại" },
    { value: "exception", label: "Ngoại lệ" },
    { value: "damage", label: "Hư hỏng" },
    { value: "lost", label: "Mất" },
    { value: "return", label: "Trả hàng" },
    { value: "waiting_to_return", label: "Đang chờ trả hàng" },
    { value: "return_transporting", label: "Đang vận chuyển trả hàng" },
    { value: "return_sorting", label: "Đang phân loại trả hàng" },
    { value: "refunded", label: "Đã hoàn tiền" },
    { value: "returning", label: "Đang trả hàng" },
    { value: "returned", label: "Đã trả hàng" },
    { value: "confirmed", label: "Đã xác nhận" },
  ];
  breadCrumbItems;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  listDevices;
  get form() {
    return this.formData.controls;
  }
  filter = {
    type_id: "",
    phone: "",
    month: "",
    year: "",
    isUsed: "",
    email: "",
    active: "",
    code: "",
    recipientPhone: "",
    status: "",
    reportType: "",
    deliveryMethod: "",
    startDate: null,
    search: "",
    endDate: null,
    referrer: "",
    terminal_bank_acc: "",
    serial_number: "",
    giveawayType: "",
  };

  listAgencies = [];
  giveawayTypeOptions = [
    { value: "normal_giveaway", label: "Tặng loa bình thường" },
    { value: "permanent_giveaway", label: "Tặng loa hẳn" },
  ];

  ngOnInit() {
    this.breadCrumbItems = [
      { label: "PAGE.HOME" },
      { label: "PAGE.REPORT.IncidentType", active: true },
    ];
    if (this.full_name.includes("DD")) console.log("DD");
    this.fetchData();
    this.fetchAgencies();
    this.range.valueChanges.subscribe((rangeValues) => {
      const formatDate = (date: Date | null) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.filter.startDate = formatDate(rangeValues.start);
      this.filter.endDate = formatDate(rangeValues.end);
    });
    this.date.valueChanges.subscribe((selectedMonth) => {
      if (selectedMonth && selectedMonth.selectedMonth) {
        const year = selectedMonth.selectedMonth.getFullYear();
        const month = String(
          selectedMonth.selectedMonth.getMonth() + 1
        ).padStart(2, "0");
        this.filter.month = month;
        this.filter.year = year;
      }
    });
  }

  date = new FormGroup({
    selectedMonth: new FormControl(null),
  });

  selectedMonth: { month: string; year: string } | null = null;

  fetchAgencies() {
    this.apiService.getList("agency").subscribe({
      next: (res: any) => {
        this.listAgencies = res?.metadata?.agency || [];
      },
    });
  }

  onMonthSelected(event: Date, datepicker: MatDatepicker<Date>) {
    const year = event.getFullYear();
    const month = event.getMonth();
    this.date.controls["selectedMonth"].setValue(new Date(year, month, 1));
    console.log("📅 Tháng được chọn:", { month: month + 1, year });
    datepicker.close();
  }

  handleOrder(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn tạo đơn hàng?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService
          .postItem(`admin/customer-orders/` + data.id, {})
          .subscribe({
            next: () => {
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Tạo đơn hàng thành công")
              );
              this.fetchData();
            },
            error: (err) => {
              if (err === "Internal Server Error") {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant("Lỗi máy chủ")
                );
              } else {
                this.apiService.showToastMobile("error", err);
              }
            },
          });
      }
    });
  }

  onLink(data, contentLink) {
    this.getCountDevice(data.id);
    this.formData = this.makeForm(data);
    this.modalService.open(contentLink, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  deviceLink(data) {
    const dataPost = {
      serialNumbers: data.serial_number,
      customerOrderId: data.id,
      workspaceId: data.workspace_id,
    };
    this.apiService.postItem("cs/device-subscription", dataPost).subscribe({
      next: (res) => {
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Liên kết thành công")
        );
        this.modalService.dismissAll();
        this.eventService.setLoading(false);
        this.fetchData();
      },
      error: (e) => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant("Liên kết thất bại")
        );
        this.eventService.setLoading(false);
      },
    });
  }

  clearFilter() {
    this.params = "";
    this.filter.serial_number = "";
    this.filter.type_id = "";
    this.filter.code = "";
    this.filter.status = "";
    this.filter.isUsed = "";
    this.filter.active = "";
    this.filter.giveawayType = "";
    // this.filter.status = "";
    this.filter.referrer = "";
    this.filter.recipientPhone = "";
    this.filter.phone = "";
    this.filter.email = "";
    this.filter.terminal_bank_acc = "";
    this.filter.deliveryMethod = "";
    this.filter.startDate = null;
    this.filter.endDate = null;
    this.filter.reportType = "";
    this.filter.search = "";
    this.range.reset();
    this.pageIndex = 1;
    this.searching = false;
    this.fetchData();
  }

  submitFilter() {
    this.params = "";
    this.pageIndex = 1;
    this.searching = true;

    for (const key in this.filter) {
      const value = this.filter[key];
      if (value !== null && value !== undefined && value !== "") {
        this.params += `&${key}=${encodeURIComponent(value)}`;
      }
    }

    this.fetchData();
  }
  exportVoucher() {
    this.submitted = true;

    const value = this.filter;
    // Validate tối thiểu
    // if (!value.voucherCode && !value.phone && !value.referrer) {
    //   this.apiService.showToastMobile(
    //     "warning",
    //     this.translateService.instant("Vui lòng nhập ít nhất 1 điều kiện lọc")
    //   );
    //   return;
    // }

    this.eventService.setLoading(true);

    // Build query string
    const params: any = {};

    if (value.code) params.code = value.code;
    if (
      value.active !== "" &&
      value.active !== null &&
      value.active !== undefined
    )
      params.active = value.active;
    if (
      value.isUsed !== "" &&
      value.isUsed !== null &&
      value.isUsed !== undefined
    )
      params.isUsed = value.isUsed;
    if (value.giveawayType) params.giveawayType = value.giveawayType;
    if (value.startDate) params.startDate = value.startDate;
    if (value.endDate) params.endDate = value.endDate;
    if (this.totalCount) params.limit = this.totalCount;

    params.page = 1; // luôn có

    // Convert sang query string
    const queryString = new URLSearchParams(params).toString();

    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = `vouchers/export?${queryString}`;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);

        const now = new Date();
        const formattedDate = `${now.getFullYear()}-${String(
          now.getMonth() + 1
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

        const fileName = `bao-cao-su-dung-voucher_${formattedDate}.xlsx`;
        saveAs(res, fileName);

        this.modalService.dismissAll();
      },
      error: (e) => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant(e || "Xuất file lỗi")
        );
        this.eventService.setLoading(false);
      },
    });
  }
  onCheckPayment(data) {
    this.apiService.checkOrderPayment(data).subscribe({
      next: (res: any) => {
        const status = res?.status || res?.metadata?.status;
        this.checkedOrderStatus = status;
        this.checkedOrderData = res.order || res.data || data;
        this.showOrderStatusPopup = true;
      },
      error: (err) => {
        this.showOrderStatusPopup = false;
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.error?.message ||
            this.translateService.instant(
              "Không kiểm tra được trạng thái thanh toán"
            ),
          "error"
        );
      },
    });
  }
  requestId: string | null = null;
  isSendingOtp = false;
  otpError = "";

  sendOtp() {
    this.isSendingOtp = true;
    this.otpError = "";

    this.apiService.postItem("vouchers/batch/sync-otp", {}).subscribe({
      next: (res: any) => {
        this.isSendingOtp = false;
        this.requestId = res?.metadata?.requestId;

        if (!this.requestId) {
          this.otpError = "Không lấy được requestId từ API!";
          return;
        }

        this.apiService.showToastMobile("success", "Gửi OTP thành công");
      },
      error: () => {
        this.isSendingOtp = false;
        this.otpError = "Gửi OTP thất bại. Vui lòng thử lại.";
      },
    });
  }
  createVoucherBatch(data: any) {
    const dataPost = {
      requestId: this.requestId,
      otpValue: data.otpValue,
      quantity: data.quantity,
      prefix: data.prefix || null,
      description: data.description || null,
      agencyIds: data.agencyIds?.length ? data.agencyIds : undefined,
      startAt: data.startAt || undefined,
      endAt: data.endAt || undefined,
      giveawayType: data.giveawayType || null,
    };
    this.apiService.postItem("vouchers/batch/verify-otp", dataPost).subscribe({
      next: (res) => {
        this.apiService.showToastMobile("success", "Tạo voucher thành công!");
        this.modalService.dismissAll();
        this.formData = this.makeForm();
        this.requestId = null;
        this.fetchData();
      },
      error: (err) => {
        this.apiService.showToastMobile(
          "error",
          err || "Không thể tạo voucher"
        );
      },
    });
  }
  confirmCheckPayment() {
    this.apiService.checkOrderPayment(this.checkedOrderData).subscribe({
      next: (res: any) => {
        const status = res?.status || res?.metadata?.status;
        this.checkedOrderStatus = status;
        this.checkedOrderData = res.order || res.data || this.checkedOrderData;
        this.showOrderStatusPopup = true;
        this.fetchData();
      },
      error: (err) => {
        this.showOrderStatusPopup = false;
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.error?.message ||
            this.translateService.instant(
              "Không kiểm tra được trạng thái thanh toán"
            ),
          "error"
        );
      },
    });
  }

  closeOrderStatusPopup() {
    this.showOrderStatusPopup = false;
    this.fetchData();
  }

  orderId;
  fetchData() {
    this.eventService.setLoading(true);
    const endpoint = "vouchers?";
    const Url = `${endpoint}&page=${this.pageIndex}&limit=${this.pageSize}${this.params}`;
    this.apiService.getList(Url).subscribe({
      next: (res: any) => {
        this.listData = res.metadata?.results || [];
        this.totalCount = res.metadata.pagination.totalCount;
        this.eventService.setLoading(false);
      },
      error: (err) => {
        this.apiService.showToastMobile(
          "error",
          "Có lỗi xảy ra khi tải dữ liệu."
        );
        this.eventService.setLoading(false);
      },
    });
  }
  @ViewChild("orderDetailModal") orderDetailModal!: TemplateRef<any>;

  getOrderDetails(orderId: string): void {
    const url = `invoice-service-orders/${orderId}`;
    this.eventService.setLoading(true);
    this.apiService.getList(url).subscribe({
      next: (res: any) => {
        this.selectedOrder = res;
        this.eventService.setLoading(false);

        // Mở modal
        this.modalService.open(this.orderDetailModal, { size: "lg" });
      },
      error: (err) => {
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.message ||
            this.translateService.instant("Lấy chi tiết đơn hàng thất bại"),
          "error"
        );
        this.eventService.setLoading(false);
      },
    });
  }
  countDevice;
  getCountDevice(id) {
    this.apiService
      .getList("cs/device-subscription?customerOrderId=" + id)
      .subscribe({
        next: (res) => {
          this.formData.patchValue({
            quantity: res.metadata.missingDevices,
          });
        },
      });
  }

  isAllSelected: boolean = false;

  checkIfAllSelected(): void {
    this.isAllSelected = this.listData
      .filter((item) => item.order_info?.status === "PAID")
      .every((item) => item.selected);
  }

  toggleAllSelections(): void {
    this.listData.forEach((item) => {
      if (item.order_info?.status === "PAID") {
        item.selected = this.isAllSelected;
      }
    });
  }

  // ...

  checkSelectedOrders(): void {
    const selectedOrderIds = this.listData
      .filter((order) => order.selected)
      .map((order) => order.id);

    if (selectedOrderIds.length === 0) {
      this.apiService.showToast(
        this.translateService.instant("FORM.Warning"),
        this.translateService.instant("Vui lòng chọn ít nhất một đơn hàng"),
        "warning"
      );
      return;
    }

    const payload = { orderIds: selectedOrderIds };

    this.eventService.setLoading(true);

    this.http
      .post("acc-viettel-invoice/template-import-accounts", payload, {
        responseType: "blob",
      })
      .subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          saveAs(res, "Danh_sach_don_hang.xlsx");
        },
        error: (err) => {
          this.eventService.setLoading(false);
          this.apiService.showToast(
            this.translateService.instant("FORM.Error"),
            err?.message ||
              this.translateService.instant("Tải xuống danh sách thất bại"),
            "error"
          );
        },
      });
  }

  base64ToUint8Array(base64: string): Uint8Array {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  onUpdate(data: any) {
    // logic kiểm tra trạng thái thanh toán
  }

  onEdit(data, content) {
    this.orderId = data.id;
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  onCreate(content) {
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  openCreateVoucherBatchModal(content) {
    this.submitted = false;
    this.requestId = null;
    this.otpError = "";
    this.formData = this.makeForm();
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }
  selectedIncident = null;
  selectedKeyword = null;
  exportExel() {
    this.submitFilter();
    this.eventService.setLoading(true);

    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "reports/export-orders?" + this.params;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);
        saveAs(res, "Bao_cao.xlsx");
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }

  exportExelBranch() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "dashboard/device-branch?model=export";

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);
        saveAs(res, "Bao_cao_chi_nhanh.xlsx");
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }

  downloadTemplate(): void {
    this.eventService.setLoading(true);
    const url = "acc-viettel-invoice/download-template";
    const headers = new HttpHeaders({
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (blob: Blob) => {
        saveAs(blob, "Mau_nhap_lieu_hoa_don.xlsx");
        this.eventService.setLoading(false);
      },
      error: (err) => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant("Tải file mẫu thất bại!")
        );
        this.eventService.setLoading(false);
      },
    });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.uploadImportFile(file);
    }
    event.target.value = null;
  }

  uploadImportFile(file: File): void {
    this.eventService.setLoading(true);
    const formData = new FormData();
    formData.append("file", file, file.name);

    const url = "acc-viettel-invoice/import-excel";

    this.http.post<any>(url, formData).subscribe({
      next: (res) => {
        const successCount = res?.metadata?.success ?? 0;
        const errorCount = res?.metadata?.failed ?? 0;
        const errors = res?.metadata?.errors ?? [];

        if (successCount > 0) {
          this.apiService.showToast(
            this.translateService.instant("FORM.Success"),
            `Import thành công ${successCount} bản ghi, thất bại ${errorCount}.`,
            "success"
          );
        } else {
          this.apiService.showToast(
            this.translateService.instant("FORM.Error"),
            `Tất cả bản ghi đều thất bại (${errorCount}).`,
            "error"
          );
        }

        if (errors.length > 0) {
          console.table(errors); // hoặc show ra dialog chi tiết nếu muốn
        }

        this.fetchData();
        this.eventService.setLoading(false);
      },
      error: (err) => {
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.error?.message ||
            this.translateService.instant("Import dữ liệu thất bại!"),
          "error"
        );
        this.eventService.setLoading(false);
      },
    });
  }

  makeFormKeyword(d) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id],
    });
  }

  fetchKeyword() {
    this.dataKeyword = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`keyword?type_id=${this.selectedIncident.id}`)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.dataKeyword = [...res];
          this.eventService.setLoading(false);
        },
      });
  }

  dataKeyword = [];

  formEditKeyword: FormGroup;
  formNewKeyword: FormGroup;
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data);
    this.selectedKeyword = data;
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.editItem("keyword", value.id, value).subscribe({
          next: (res) => {
            this.selectedKeyword = null;
            this.fetchKeyword();
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.addItem("keyword", value).subscribe({
          next: (res) => {
            this.eventService.setLoading(false);
            this.formNewKeyword.reset({
              incident_type_id: this.selectedIncident.id,
            });
            this.fetchKeyword();
          },
        });
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident;
    this.fetchKeyword();
    this.formNewKeyword = this.makeFormKeyword({
      incident_type_id: this.selectedIncident.id,
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true);
      this.apiService.deleteItem("keyword", id).subscribe((res) => {
        Swal.fire(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("FORM.SuccessMessageDelete"),
          "success"
        ).then((res) => {
          this.fetchKeyword();
        });
        this.eventService.setLoading(false);
      });
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("FORM.WarningMessage"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName, data).subscribe((res) =>
          Swal.fire(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("FORM.SuccessMessageDelete"),
            "success"
          ).then((res) => {
            this.fetchData();
          })
        );
      }
    });
  }

  viewDetails(data: any) {
    this.router.navigate(["/orders-manager/detail-orders/", data.id]);
  }

  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      accountName: ["", Validators.required],
      accountPassword: ["", Validators.required],
      taxCode: ["", Validators.required],
      invoice_type: ["", Validators.required],
      template_code: ["", Validators.required],
      invoice_series: ["", Validators.required],
      business_type: ["household", Validators.required],
      quantity: [null],
      prefix: [""],
      description: [""],
      requestId: "",
      otpValue: "",
      agencyIds: [[]],
      startAt: [""],
      endAt: [""],
      giveawayType: [""],
    });
  }
  onUpdateCustomer() {
    const value = this.formData.value;
    const payload = {
      accountName: value.accountName,
      accountPassword: value.accountPassword,
      taxCode: value.taxCode,
      invoice_type: value.invoice_type,
      template_code: value.template_code,
      invoice_series: value.invoice_series,
      business_type: value.business_type,
      orderId: this.orderId,
    };
    this.apiService
      .postItem("acc-viettel-invoice/link-account-for-partner", payload)
      .subscribe({
        next: (res) => {
          this.apiService.showToast(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("Cập nhất tài khoản thành công"),
            "success"
          );
          this.fetchData();
        },
        error: (err) => {
          this.apiService.showToast(
            this.translateService.instant("FORM.Error"),
            this.translateService.instant(err || "Cập nhất tài khoản thất bại"),
            "error"
          );
        },
      });
  }
  saveData() {
    this.submitted = true;
    if (this.formData.valid) {
      const value = this.formData.value;
      value["status"] = value["status"] == true ? 1 : 0;
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData.reset();
            this.fetchData();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem(this.tableName, value).subscribe({
          next: (res) => {
            this.fetchData();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessageAdd"),
              "success"
            );
            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessageAdd"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      console.log("invalid", this.formData);
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  selectedOrder: any = null;
  public showOrderStatusPopup: boolean = false;
  public checkedOrderStatus: string = "";
  public checkedOrderData: any = null;
}
